import { render, staticRenderFns } from "./story-page-hero.vue?vue&type=template&id=517c6067&scoped=true&"
import script from "./story-page-hero.vue?vue&type=script&lang=js&"
export * from "./story-page-hero.vue?vue&type=script&lang=js&"
import style0 from "./story-page-hero.vue?vue&type=style&index=0&id=517c6067&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "517c6067",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/home/forge/inspireyourtribe.salamander.dev/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('517c6067')) {
      api.createRecord('517c6067', component.options)
    } else {
      api.reload('517c6067', component.options)
    }
    module.hot.accept("./story-page-hero.vue?vue&type=template&id=517c6067&scoped=true&", function () {
      api.rerender('517c6067', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "resources/js/components/pageParts/story-page-hero.vue"
export default component.exports